import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Star, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from './ui/CountdownTimer';
import { PriceDisplay } from './ui/PriceDisplay';
import { CART_LINK } from '../lib/constants';
import { trackEvent } from '../lib/metaPixel';
const bonuses = [{
  num: 1,
  title: 'GUÍA CICLO EN CALMA 5x5',
  value: '29.900',
  shortDesc: 'Aprendé qué hacer durante los 5 días antes de que te venga para acompañar dolor, hinchazón, antojos, cansancio y cambios de humor.',
  longDesc: 'Tu plan simple para los 5 días antes del periodo: qué hacer, qué comer y cómo acompañar tu cuerpo para llegar mejor.',
  img: 'https://cdn.magicpatterns.com/uploads/6qxSDwCaeskzneet1MLLpX/ChatGPT_Image_21_may_2026,_07_31_00_p.m..png',
  review: 'Me encantó porque no es teoría eterna. Es concreto, simple y me dijo exactamente qué hacer esos días.',
  reviewer: 'Paula, 25 años'
}, {
  num: 2,
  title: 'BONUS RECETAS RÁPIDAS 5+5',
  value: '14.999',
  shortDesc: 'Recetas, snacks, menús simples y lista de compras para no tener que pensar demasiado esos días.',
  longDesc: 'Comidas fáciles para los 5 días antes y los 5 días durante el periodo, con snacks, menús y lista de compras.',
  img: 'https://cdn.magicpatterns.com/uploads/n7qhs2CSB3p7Nexe1Kye1P/ChatGPT_Image_21_may_2026,_07_32_43_p.m..png',
  review: 'Me resolvió muchísimo el "qué como" cuando estoy hinchada o con antojos. Súper simple.',
  reviewer: 'Milagros, 30 años'
}, {
  num: 3,
  title: 'TRACKER NOTION 5x5',
  value: '14.900',
  shortDesc: 'Registrá qué te pasa, cuándo te pasa y qué cosas te ayudan o empeoran tus síntomas.',
  longDesc: 'Una herramienta para registrar dolor, humor, sueño, energía, hinchazón y detectar tu patrón real.',
  img: 'https://cdn.magicpatterns.com/uploads/pyhb9HE8RPPontw3FdMygc/ChatGPT_Image_21_may_2026,_07_34_35_p.m..png',
  review: 'El tracker fue de mis partes favoritas. Me hizo dar cuenta de cosas que nunca había visto de mi ciclo.',
  reviewer: 'Florencia, 28 años'
}, {
  num: 4,
  title: 'MEDITACIÓN VOLVER A MÍ',
  value: '9.900',
  shortDesc: 'Una pausa guiada para bajar revoluciones y volver a vos cuando sentís que todo te supera.',
  longDesc: 'Un audio guiado para usar cuando aparece ansiedad, irritabilidad, insomnio, llanto o sobrepensamiento.',
  img: 'https://cdn.magicpatterns.com/uploads/f1ZcRqfw5K2z3aQTMZrxD4/ChatGPT_Image_21_may_2026,_07_37_17_p.m..png',
  review: 'La escuché antes de dormir y me ayudó a bajar muchísimo la cabeza en esos días.',
  reviewer: 'Delfina, 23 años'
}, {
  num: 5,
  title: 'BONUS QUÉ HACER DURANTE EL PERIODO',
  value: '13.000',
  shortDesc: 'Una guía práctica para atravesar esos días sin sentir que tenés que bancártela sola.',
  longDesc: 'Una guía para acompañarte durante los 5 días del periodo: dolor, trabajo, facultad, pareja, descanso y emociones.',
  img: 'https://cdn.magicpatterns.com/uploads/kHdjQZJQXgoWGHZ8BrGQfN/ChatGPT_Image_21_may_2026,_07_41_26_p.m..png',
  review: 'Sentí que el kit me acompañaba completo, no solo antes del periodo sino también durante esos días.',
  reviewer: 'Antonella, 32 años'
}, {
  num: 6,
  title: 'IA CICLO EN CALMA',
  value: '19.900',
  shortDesc: 'Un ChatGPT experto en Ciclo en Calma para que le consultes cualquier duda o pregunta sobre tu premenstrual y menstruación, entrenada con todas las guías.',
  longDesc: 'Un ChatGPT experto en Ciclo en Calma, entrenado con todas las guías, para que le consultes cualquier duda sobre tu premenstrual y menstruación, las 24 horas.',
  img: 'https://cdn.magicpatterns.com/uploads/dLBW8HZLj1p6q9awMzjVC9/ChatGPT_Image_21_may_2026,_07_43_07_p.m..png',
  review: 'Lo uso como si fuese mi mejor amiga experta. Le pregunto a cualquier hora y me responde clarísimo.',
  reviewer: 'Renata, 26 años',
  isNew: true
}];
export function ValueStack() {
  return <section id="value-stack" className="py-20 bg-dark px-4 sm:px-6 lg:px-8 relative overflow-hidden scroll-mt-16" data-id="element-280">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=1600&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-281"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-283">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 text-[#EEFF00]" data-id="element-284">
            Todo lo que te llevas hoy
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-285">
            Todo lo que necesitás para prepararte antes del periodo, entender tu
            ciclo y atravesar esos días con más calma, menos dolor y menos
            improvisación.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-286">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-white rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-stretch gap-6 md:gap-8 shadow-xl border border-gold/30 relative overflow-hidden" data-id="element-287">
              <div className="absolute top-0 left-0 w-2 h-full bg-burgundy" data-id="element-288"></div>

              {bonus.isNew && <div className="absolute top-3 right-3 bg-gold text-dark font-bold text-xs px-3 py-1 rounded-full flex items-center shadow-md z-10" data-id="element-289">
                  <Sparkles className="w-3 h-3 mr-1" data-id="element-290" /> NUEVO
                </div>}

              {/* Image */}
              <div className="w-full md:w-2/5 flex-shrink-0" data-id="element-291">
                <img src={bonus.img} alt={bonus.title} className="w-full h-64 md:h-full md:min-h-[320px] object-cover object-center rounded-xl shadow-md bg-cream" data-id="element-292" />
              </div>

              {/* Content */}
              <div className="w-full md:w-3/5 flex flex-col justify-center" data-id="element-293">
                <div className="flex items-center space-x-3 mb-3" data-id="element-294">
                  <span className="w-8 h-8 rounded-full bg-burgundy text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-295">
                    {bonus.num}
                  </span>
                  <h3 className="font-serif font-bold text-xl md:text-2xl text-dark" data-id="element-296">
                    {bonus.title}
                  </h3>
                </div>

                <div className="mb-3 flex flex-wrap items-center gap-2" data-id="element-297">
                  <span className="text-gray-400 line-through text-sm" data-id="element-298">
                    Valor: ${bonus.value} ARS
                  </span>
                  <span className="text-burgundy font-bold text-sm bg-burgundy/10 px-2 py-1 rounded" data-id="element-299">
                    INCLUIDO GRATIS
                  </span>
                </div>

                <p className="text-gray-700 leading-relaxed mb-5" style={{
              fontSize: '16px'
            }} data-id="element-300">
                  {bonus.longDesc}
                </p>

                {/* Review */}
                <div className="bg-cream p-4 rounded-xl border-l-4 border-gold mt-auto" data-id="element-301">
                  <div className="flex text-gold mb-2" data-id="element-302">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-303" />)}
                  </div>
                  <p className="text-gray-800 italic mb-2 text-sm md:text-base" data-id="element-304">
                    "{bonus.review}"
                  </p>
                  <p className="text-xs md:text-sm font-bold text-dark" data-id="element-305">
                    — {bonus.reviewer}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* PRICING CARD — moved from PricingSection, now at the end of ValueStack */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 bg-white rounded-3xl shadow-2xl p-6 md:p-12 border-2 border-gold/30 relative text-center" data-id="element-306">
          {/* Badge */}
          <div className="absolute -top-6 right-4 md:-right-6 bg-burgundy text-white font-bold py-3 px-6 rounded-full shadow-lg transform rotate-[-8deg] border-2 border-gold text-xl z-10" data-id="element-307">
            70% OFF
          </div>

          {/* PRICE FIRST */}
          <div className="space-y-3 mb-8 pt-4" data-id="element-308">
            <p className="text-gray-500 font-medium text-base md:text-lg" data-id="element-309">
              Valor Total Normal
            </p>
            <p className="text-2xl md:text-3xl text-gray-400 line-through font-serif decoration-burgundy/50 decoration-2" data-id="element-310">
              <PriceDisplay amount="102.599" data-id="element-311" />
            </p>

            <div className="py-4" data-id="element-312">
              <p className="text-burgundy font-bold text-lg md:text-xl mb-2 uppercase tracking-wide" data-id="element-313">
                Precio Especial — Hot Sale
              </p>
              <div className="text-5xl md:text-7xl font-serif font-bold text-dark flex items-center justify-center leading-none" data-id="element-314">
                <PriceDisplay amount="17.990" data-id="element-315" />
              </div>
              <p className="text-gray-500 mt-2 font-medium text-sm" data-id="element-316">
                Pesos Argentinos
              </p>
            </div>
          </div>

          {/* RED URGENCY COUNTDOWN BOX */}
          <div className="mb-8" data-id="element-317">
            <CountdownTimer variant="urgent" data-id="element-318" />
          </div>

          {/* CTA */}
          <a href={CART_LINK} onClick={e => {
          // Fire the Meta Pixel AddToCart event, then redirect after a short
          // delay so the event has time to reach Meta before we leave the page.
          e.preventDefault();
          const href = CART_LINK;
          trackEvent('AddToCart', {
            content_name: 'Kit 5x5 Ciclo en Calma',
            content_category: 'Digital Product',
            content_ids: ['kit-5x5-ciclo-en-calma'],
            content_type: 'product',
            currency: 'ARS',
            value: 17990
          });
          // 500ms is enough for the pixel beacon to fire reliably.
          window.setTimeout(() => {
            window.location.href = href;
          }, 500);
        }} className="block w-full bg-burgundy hover:bg-burgundy-dark text-white font-bold text-xl md:text-2xl py-5 md:py-6 px-8 rounded-xl shadow-[0_8px_30px_rgba(107,15,26,0.4)] transition-all transform hover:scale-[1.02] mb-6" data-id="element-319">
            COMPRAR (70% OFF)
          </a>

          <div className="flex flex-col items-center justify-center space-y-3 text-sm text-gray-700 font-medium bg-gray-50 py-4 rounded-lg" data-id="element-320">
            <div className="flex items-center space-x-4" data-id="element-321">
              <span className="flex items-center" data-id="element-322">
                <Lock className="w-4 h-4 mr-1 text-burgundy" data-id="element-323" /> Pago Seguro
              </span>
              
            </div>
            <div className="flex items-center space-x-2" data-id="element-324">
              <CreditCard className="w-4 h-4 text-burgundy" data-id="element-325" />
              <span data-id="element-326">Mercado Pago · Todas las Tarjetas</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}